export enum ETypMatky {
    IS_DIRECTLY_CONSOLIDATED_BY = 'IS_DIRECTLY_CONSOLIDATED_BY', // prima matka
    IS_ULTIMATELY_CONSOLIDATED_BY = 'IS_ULTIMATELY_CONSOLIDATED_BY', // finalni matka
    IS_INTERNATIONAL_BRANCH_OF = 'IS_INTERNATIONAL_BRANCH_OF', // matka pre typZadosti BRANCH
    IS_FUND_MANAGED_BY = 'IS_FUND-MANAGED_BY', // - je tu spravne neopravovat
    IS_SUBFUND_OF = 'IS_SUBFUND_OF',
    IS_FEEDER_TO = 'IS_FEEDER_TO'
}
export enum ETypDatMatky {
    ACCOUNTS_FILING = 'ACCOUNTS_FILING', // Výroční zpráva/Účetní závěrka
    REGULATORY_FILING = 'REGULATORY_FILING', // Smlouvy REGULATORY_FILING
    SUPPORTING_DOCUMENTS = 'SUPPORTING_DOCUMENTS', // Smlouvy SUPPORTING_DOCUMENTS
    CONTRACTS = 'CONTRACTS', // Smlouvy CONTRACTS
    OTHER_OFFICIAL_DOCUMENTS = 'OTHER_OFFICIAL_DOCUMENTS' // Jiné dokumenty
}
export enum EPeriodType {
    DOCUMENT_FILING_PERIOD = 'DOCUMENT_FILING_PERIOD', // pro dokument
    ACCOUNTING_PERIOD = 'ACCOUNTING_PERIOD', // pro učetni období
    RELATIONSHIP_PERIOD = 'RELATIONSHIP_PERIOD'
}
export enum EKonsolidace {
    US_GAAP = 'US_GAAP',
    IFRS = 'IFRS',
    OTHER_ACCOUNTING_STANDARD = 'OTHER_ACCOUNTING_STANDARD',
    GOVERNMENT_ACCOUNTING_STANDARD = 'GOVERNMENT_ACCOUNTING_STANDARD'
}

export enum ETypZadostiLei {
    GENERAL = 'GENERAL',
    FUND = 'FUND',
    BRANCH = 'BRANCH',
    SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
    RESIDENT_GOVERNMENT_ENTITY = 'RESIDENT_GOVERNMENT_ENTITY',
    INTERNATIONAL_ORGANIZATION = 'INTERNATIONAL_ORGANIZATION'
}
export enum ESubCategoryLei {
    CENTRAL_GOVERNMENT = 'CENTRAL_GOVERNMENT',
    STATE_GOVERNMENT = 'STATE_GOVERNMENT',
    LOCAL_GOVERNMENT = 'LOCAL_GOVERNMENT',
    SOCIAL_SECURITY = 'SOCIAL_SECURITY'
}

export enum EStavKontrolaMigrace {
    LEINEEXISTUJE = 'LEINEEXISTUJE',
    STEJNYUCET = 'STEJNYUCET',
    ZADOST = 'ZADOST',
    PREVODEMAIL = 'PREVODEMAIL',
    PREVODHESLO = 'PREVODHESLO',
    DUPLICITA = 'DUPLICITA'
}
